import Vue from 'vue';
import crypto from 'crypto';
import getUrl  from './getUrl'
import { Toast } from 'vant';
const _ = require("lodash");
const baseURL = process.env.NODE_ENV === 'development' ?  'https://walletapidev.bitdisk.io:4443/SEJ/#' : 'https://walletapi.bitdisk.io/SEJ/#';
const baseShareURL = process.env.NODE_ENV === 'development' ?  'https://walletapidev.bitdisk.io:4443/spread/activity-dev/#/register?code=' : 'https://walletapi.bitdisk.io/spread/activity/#/register?code=';
const baseBitdiskShareURL = process.env.NODE_ENV === 'development' ?  'https://api-bitdisk-dev.cume.cc/register.html?ccode=WCR001&icode=' : 'https://api-bitdisk.cume.cc/register.html?ccode=WCR001&icode=';

require('./date-utils.min');

//扩展公共方法
Vue.mixin({
  data(){
    return{
      baseURL,
      baseShareURL,
      baseBitdiskShareURL,
      getUrl
    }
  },
  methods: {
    // 设置新的订单对应的二维码有效时间
    setOrderIdQrcode(orderId, qrcode){
      let data = {
        qrcode,
        t: new Date().getTime()
      }
      sessionStorage.setItem(orderId, JSON.stringify(data));
    },
    //获取订单对应二维码
    getOrderIdQrcode(orderId){
      let data = sessionStorage.getItem(orderId);
      return data ? JSON.parse(data) : null
    },
    getEnvParam(name = 'NODE_ENV'){
      return process.env[name]
    },
    inputfocusKeybordShow(){
      setTimeout(()=>{
        window.scrollTo(0,document.body.clientHeight);
      }, 800)
    },
    async toggleCollect(state, that, loadingLoader, cb = function() {}) {
      that.good['price'] = this.getTypedPriceRet(that.good).price; // 快照当时优惠价格
      if( loadingLoader ) that.good['loadingLoader'] = loadingLoader
      let skuIds = { 'skuIds': [that.good.skuId] };
      console.log(skuIds, '--------44------------------------------------------', that.good);
      let res = state == '1'
        ? await this.$api._collectSave(that.good)
          : await this.$api._collectCancel(skuIds)
      
      cb && cb(res, that)
    },
    goAppHome(){
      let data = {
        "cmd": 'toMain',
        "param": {

        }
      }
      console.log(data)
      try{
        window.webkit.messageHandlers.bridgeCmd.postMessage(data)
      }catch(e){
        console.log(e)
      }
      try{
        helper.bridgeCmd(JSON.stringify(data))
      }catch(e){
        console.log(e)
      }
    },
    goBack(){
      this.appCmdApply('goBack');// APP中APP处理回退逻辑  
    },
    isJsonString(str) {
      try {
        if (typeof JSON.parse(str) == "object") {
          return true;
        }
      } catch(e) {}
      return false;
    },
    /**
     *
     * @param url 图片路径
     * @param ext 图片格式
     * @param callback 结果回调
     */
    getUrlBase64(url, ext = 'jpg', callback) {
      var canvas = document.createElement("canvas");   //创建canvas DOM元素
      var ctx = canvas.getContext("2d");
      var img = new Image;
      img.crossOrigin = 'Anonymous';
      img.src = url;
      img.onload = function () {
        canvas.height = 375; //指定画板的高度,自定义
        canvas.width = 375; //指定画板的宽度，自定义
        ctx.drawImage(img, 0, 0, 375, 375); //参数可自定义
        var dataURL = canvas.toDataURL("image/jpeg" + ext, 0.2);
        callback.call(this, dataURL); //回掉函数获取Base64编码
        canvas = null;
      };
    },
    base64ToBlob (code) {
      let parts = code.split(';base64,')
      let contentType = parts[0].split(':')[1]
      let raw = window.atob(parts[1])
      let rawLength = raw.length
      let uInt8Array = new Uint8Array(rawLength)
      for (let i = 0; i < rawLength; ++i) {
          uInt8Array[i] = raw.charCodeAt(i)
      }
      return new Blob([uInt8Array], {type: contentType})
    },
    saveImgFile(data, filename) {
      // const save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
      // save_link.href = data;
      // save_link.download = filename;
  
      // const event = document.createEvent('MouseEvents');
      // event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      // save_link.dispatchEvent(event);
      let aLink = document.createElement('a')
      let blob = this.base64ToBlob(data)
      let evt = document.createEvent('HTMLEvents')
      evt.initEvent('click', true, true)
      aLink.download = `${filename}.jpg`
      aLink.href = URL.createObjectURL(blob)
      aLink.click()
    },
    getGoodType(good) {
      let type = 'hotGoods'
      if(!good || !good.skuId) return type

      if(good.couponInfo && good.couponInfo.link){
        type = 'goodCoupon'
      }else if(good.seckillInfo && good.seckillInfo.seckillPrice){
        type = 'seckill'
      }else if(good.pinGouInfo && good.pinGouInfo.pingouUrl){
        type = 'pinGou'
      }else{
        type = 'hotGoods'
      }      
      // console.log('--------104------------------------------------------', type);
      return type
    },
    getTypedPriceRet(good, type){
      if(!good || !good.skuId) return 0
      let _type = this.getGoodType(good);
      let ret = {
        orginPrice: 0,
        price: 0
      }
      
      switch (_type){
        case 'hotGoods':
          delete ret.orginPrice // 不显示原价
          ret.price = good.priceInfo.price
        break;
        case 'goodCoupon':
          ret.orginPrice = good.priceInfo.lowestPrice
          ret.price = good.priceInfo.lowestCouponPrice || good.priceInfo.lowestPrice
        break;
        case 'pinGou':
          ret.orginPrice = good.priceInfo.price
          ret.price = good.pinGouInfo.pingouPrice
        break;
        case 'seckill':
          ret.orginPrice = good.seckillInfo.seckillOriPrice
          ret.price = good.seckillInfo.seckillPrice
        break;
      }
      // console.log(_type, '--------159------------------------------------------', ret);

      return ret
    },
    /**
     * @param path 带参数的某个商城地址 如/details?productId=9eb1ec9f0c166aa6bb170921adab7d9b
    */
    goShopWithToken(path = '/index') {
      let pre_shop_url = this.getEnvParam('SHOP_URL')
      console.log('--------60------------------------------------------', pre_shop_url);
      // 带token跳转商城某个路劲
      this.appCmdApply('toUrlByToken', {
        url: `${pre_shop_url}api/oauth/wallet/login?t=${new Date().getTime()}&redirectUrl=${encodeURI(path)}&token=`
      })
    },
    appCmdApply(cmd='close', param={}, cbn=null){
      let data = {
        "cmd": cmd,
        "param": param
      }
      if(cbn) data['cbn'] = cbn
      console.log('cmd---->', data);
      let type = this.isAndroid();
      try{
        if ( type == 1){
          // 安卓
          helper.bridgeCmd(JSON.stringify(data))
        }else if(type == 2){
          // IOS
          window.webkit.messageHandlers.bridgeCmd.postMessage(data)
        }else {
          console.log('cmd->', cmd)
        }
      }catch(e){
        console.log('cmd->', cmd)
        if(cmd == 'goBack') {
          window.history.go(-1);
        } else if ( cmd == "openLinkWithBrowser" ){
          window.location.href = param.url
        }
      }
    },
    toPageWithBack(url, romoto = 'LOCAL') {
      let that = this;
      console.log('url------>', getUrl(url, romoto) + url);

      let data = {
        "cmd": 'openlink',
        "param": {
          url:getUrl(url, romoto) + url
        }
      }
      let type = this.isAndroid();
      let errRouteFunc = function () {
        if(romoto== 'LOCAL') { 
          that.$router.push({path: url});
        }else {
          window.location.href = getUrl(url, romoto) + url
        }
      }

      if ( type == 1){
        // 安卓跳转
        try{
          helper.bridgeCmd(JSON.stringify(data))
        }catch(e){
          console.log(e)
          errRouteFunc()
        }
      }else if(type == 2){
        // IOS跳转
        try{
          window.webkit.messageHandlers.bridgeCmd.postMessage(data)
        }catch(e){
          console.log(e)
          errRouteFunc()
        }
      }else {
        errRouteFunc()
      }
      
    },
    goBackToApp(){
      let type = this.isAndroid();
      if ( type == 1){
        try {
          var iframe = document.createElement('iframe');

          iframe.src = "hdtw://pay?authRet"; // URL scheme的方式跳转

          iframe.style.display = 'none';

          document.body.appendChild(iframe); 
          
        } catch (error) {
          console.log('--------115------------------------------------------', error);
        }
      }else if(type == 2){
        window.location.href = 'btdw://';
      }     
        
    },
    toForgetPwd(){
      let data = {
        "cmd": 'openForgetPwd',
        "param": {
         
        }
      }
      let type = this.isAndroid();

      if ( type == 1){
        // 安卓跳转
        try{
          helper.bridgeCmd(JSON.stringify(data))
        }catch(e){
          console.log(e)
          Toast("跳转找回密码遇到未知错误");
        }
      }else if(type == 2){
        // IOS跳转
        try{
          window.webkit.messageHandlers.bridgeCmd.postMessage(data)
        }catch(e){
          console.log(e)
          Toast("跳转找回密码遇到未知错误");
        }
      }else {
        
      }
    },
    toShareLink(){
      let data = {
        "cmd": 'openInvitecode',
        "param": {
         
        }
      }
      let type = this.isAndroid();

      if ( type == 1){
        // 安卓跳转
        try{
          helper.bridgeCmd(JSON.stringify(data))
        }catch(e){
          console.log(e)
          Toast('分享遇到未知错误');
        }
      }else if(type == 2){
        // IOS跳转
        try{
          window.webkit.messageHandlers.bridgeCmd.postMessage(data)
        }catch(e){
          console.log(e)
          Toast('分享遇到未知错误')
        }
      }else {
        
      }
    },
    encryption(key, data) {// 图形密码加密aes
      console.log(key, data, 'key, data)----------------------')
      const iv = Buffer.alloc(16)
      const cipher = crypto.createCipheriv('aes-256-cbc', key, iv)
      let output = cipher.update(data, 'utf8', 'base64')
      output += cipher.final('base64')
      return output
    },
    uuid(length) {
      length = length || 8;
      return crypto.randomBytes(parseInt(length / 2)).toString("hex").toUpperCase();
    },
    randomNum(minNum,maxNum){ 
      switch(arguments.length){ 
        case 1: 
          return parseInt(Math.random()*minNum+1,10); 
        case 2: 
          return parseInt(Math.random()*(maxNum-minNum+1)+minNum,10); 
        default: 
          return 0; 
      } 
    },
    isFullTextFill(str, len = 3){
      if(!str) return '0000'
      str = String(str);

      if(str.length<len) {
        for(let i = 0; i < len - str.length;){
          str = '0' + str;
        }
      }
      return str
    },
    goToDetailPage(path = 'detail',good, type){
      if(typeof good == 'object'){
        // &VSK=${this.$route.query.VSK}
        let _url = `/${path}?type=${type}`;
        let flag = false;
        Object.keys(good).map(key => {
          if(good[key] && key != 'type' && key != 'type') {
            _url += 
            `&${key}=${typeof good[key] == 'object' ? encodeURIComponent(JSON.stringify(good[key])) : encodeURIComponent(good[key]) }`
          }
          flag = true;
        })

        _url = _url.replace(/%/g, '%25')

        this.toPageWithBack(_url);
      }else{
        Toast('获取商品错误')
      }
    },
    goLotteyDetailPage(path) {
      // &VSK=${this.$route.query.VSK}
      let _url = `${path}`;

      this.toPageWithBack(_url);
    },
    _debounce(fn, delay) {
      var delay = delay || 200;
      var timer;
      return function () {
          var th = this;
          var args = arguments;
          if (timer) {
            clearTimeout(timer);
          }
          timer = setTimeout(function () {
              timer = null;
              fn.apply(th, args);
          }, delay);
      };
    },
    _throttle(fn, interval) {
      var last;
      var timer;
      var interval = interval || 200;
      return function () {
          var th = this;
          var args = arguments;
          var now = +new Date();
          if (last && now - last < interval) {
              clearTimeout(timer);
              timer = setTimeout(function () {
                  last = now;
                  fn.apply(th, args);
              }, interval);
          } else {
              last = now;
              fn.apply(th, args);
          }
      }
    },
    getBtrAddressSubStr(str){
      if(str.length < 12 ) return str;
      var subStr1 = str.substr(0,6);
      var subStr2 = str.substr(str.length-6,6);
      var subStr = subStr1 + "..." + subStr2 ;
      return subStr
    },
    base64(string) {
      return window.btoa(unescape(encodeURIComponent(string)));
    },
    // 过期时间
    isExpire(expireTime){
      if(!expireTime) return ' ';
      let timestamp=new Date().getTime();
      let newTime=expireTime-timestamp;
      if(newTime<=0){ // 过期
        return true;
      }
    },
    // 不足N天
    isExpireWithNdays(expireTime, n){
      if(!expireTime) return false;
      let timestamp=new Date().getTime();
      let newTime=expireTime-timestamp;
      if(newTime<=n*24*60*60*1000 ){ // 不足N天
        return true;
      }
    },
    // 判断字符的长度
    getStrLength (strVal) {
      let namelength = strVal, len=0;
      for (let i = 0; i < namelength.length; i++) {  
        if (namelength.charCodeAt(i) > 127 || namelength.charCodeAt(i)==94) {  
          len += 2;  
        } else {  
          len ++;  
        }  
      }  
      if (len>20){ // 中文最多只能输入10个字，其他最多只能输入20个字符
        return true;
      }
    },
    // 两个浮点数求和
    accAdd(num1,num2){
      var r1,r2,m;
      try{
          r1 = num1.toString().split('.')[1].length;
      }catch(e){
          r1 = 0;
      }
      try{
          r2=num2.toString().split(".")[1].length;
      }catch(e){
          r2=0;
      }
      m=Math.pow(10,Math.max(r1,r2));
      return Math.round(num1*m+num2*m)/m;
    },
    // 两个浮点数相减
    accSub(num1,num2){
      var r1,r2,m,n;
      try{
          r1 = num1.toString().split('.')[1].length;
      }catch(e){
          r1 = 0;
      }
      try{
          r2=num2.toString().split(".")[1].length;
      }catch(e){
          r2=0;
      }
      m=Math.pow(10,Math.max(r1,r2));
      n=(r1>=r2)?r1:r2;
      return (Math.round(num1*m-num2*m)/m).toFixed(n);
    },
    // 相除
    accDiv(num1,num2){
      var t1,t2,r1,r2;
      try{
          t1 = num1.toString().split('.')[1].length;
      }catch(e){
          t1 = 0;
      }
      try{
          t2=num2.toString().split(".")[1].length;
      }catch(e){
          t2=0;
      }
      r1=Number(num1.toString().replace(".",""));
      r2=Number(num2.toString().replace(".",""));
      return (r1/r2)*Math.pow(10,t2-t1);
    },
    // 相乘
    accMul(num1,num2){
      var m=0,s1=num1.toString(),s2=num2.toString(); 
      try{m+=s1.split(".")[1].length}catch(e){};
      try{m+=s2.split(".")[1].length}catch(e){};
      return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m);
    },
    // 保留2位小数 
    onlyOneNumber(val){
      if(isNaN(val)){
        return 0;
      }else{
        return parseInt(val*100)/100 ;
      }
    },
     // 保留6位小数 
     onlySixNumber(val){
      if(isNaN(val)){
        return 0;
      }else{
        return parseInt(val * 1000000) / 1000000 ;
      }
    },
     // 进度条长度 % 
    barWith(val1,val2){
      if(isNaN(val1) || isNaN(val2)){
        return 0;
      }else{
        let num = Number(val1)/Number(val2)*100;
        if(num>=100){
          return 100;
        }else{
          return Number(val1)/Number(val2)*100;
        }
      }
    },
    dateUtilIsToday(val){
      return new Date(val).isToday();
    },
    formatDateValX(val, type) {//格式化日期
      return new Date(val).toFormat(type);
    },
    formatDateVal(val) {//格式化日期
      return new Date(val).toFormat('YYYY-MM-DD');
    },
    formatDateVal2(val) {
      return new Date(val).toFormat('YYYY.MM.DD');
    },
    formatDateVal3(val) {
      return new Date(val).toFormat('MM.DD');
    }, 
    formatDateTimeVal0(val) {//格式化日期
      if(!val) return '';
      return new Date(val).toFormat('YYYY.MM.DD HH24:MI:SS');
    },  
    formatDateTimeVal8(val) {//格式化日期
      if(!val) return '';
      return new Date(val).toFormat('YYYY.MM.DD HH24:MI');
    },   
    formatDateTimeVal(val) {//格式化日期
      if(!val) return '';
      return new Date(val).toFormat('YYYY-MM-DD HH24:MI:SS');
    },
    formatDateTimeVal2(val) {//格式化日期
      if(!val) return '';
      return new Date(val).toFormat('YYYY-MM-DD-HH24MISS');
    },
    formatDateTimeVal3(val) {//格式化日期
      if(!val) return '';
      return new Date(val).toFormat('MM-DD HH24:MI:SS');
    },    
    formatDateTimeVal4(val) {//格式化日期
      if(!val) return '';
      return new Date(val).toFormat('HH24:MI');
    },  
    formatDateTimeVal5(val) {//格式化日期
      if(!val) return '';
      return new Date(val).toFormat('YYYY.MM.DD HH24:MI');
    },  
    formatDateToTimestamp(val) {
      if(!val) return Date.now();
      return new Date(val).getTime();
    },
    countDownTransform(props) {
      Object.entries(props).forEach(([key, value]) => {
        // Adds leading zero
        const digits = value < 10 ? `0${value}` : value;
        props[key] = `${digits}`;
      });
 
      return props;
    },
    // 算时长
    formatTime(obj){
      let second=this.accDiv(obj,1000);
      var d=0,h=0,m=0;
      if(second>86400){
          d=Math.floor(second/86400);
          second=second%86400;
      }
      if(second>3600){
          h=Math.floor(second/3600);
          second=second%3600;
      }
      if(second>60){
          m=Math.floor(second/60);
          second=second%60;
      }
      var result='';
      if(d<=0){
        d=0
      }
      if(h<=0){
        h=0
      }
      if(window.localStorage.getItem('lang')=='en'){
        result=d +'day'+ h + 'hours'
      }else{
        result=d +'天'+ h + '小时'
      }
    
      return result;
    },
    fmtTime1(timestamp) {
      if (!timestamp) return '';
      if (typeof timestamp == 'string') timestamp = new Date(timestamp).getTime();
      let s = 1000;
      let m = 60 * s;
      let h = 60 * m
      let d = 24 * h;
      let date = Date.now() - timestamp; 
      if (date / d >= 1) return Math.floor(date / d) + '天前'
      if (date / h >= 1) return Math.floor(date / h) + '小时前'
      if (date / m >= 1) return Math.floor(date / m) + '分钟前'
      if (date / s > 1) return Math.floor(date / s) + '秒前'
      return '1分钟前'
    },
    fmtTime2(timestamp) {
      if (!timestamp) return '';
      if (typeof timestamp == 'string') timestamp = new Date(timestamp).getTime();
      let s = 1000;
      let m = 60 * s;
      let h = 60 * m
      let d = 24 * h;
      let date = timestamp - Date.now(); 
      if (date / d >= 1) return Math.floor(date / d) + '天'
      if (date / h >= 1) return Math.floor(date / h) + '小时'
      if (date / m >= 1) return Math.floor(date / m) + '分钟'
      // if (date / s > 1) return Math.floor(date / s) + '秒'
      return '最后1分钟'
    },
    onCopy(e) {
      if(window.localStorage.getItem('lang')=='en'){
        Toast('复制成功');
      }else{
        Toast('Copy succeeded');
      }
     
    },
    onError(e) {
      if(window.localStorage.getItem('lang')=='en'){
        Toast('复制出错，请手动选择复制');
      }else{
        Toast('Copy error, please select Copy manually');
      }
    },
    isWeiXin() {
      //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      var ua = window.navigator.userAgent.toLowerCase();
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
      } else {
        return false;
      }
    },
    getSystem(){ // 获取系统类型
      let systemType='';
      if(window.navigator.userAgent.indexOf("Android") != -1){
        systemType='android';
      }else if(window.navigator.userAgent.indexOf("iPhone") != -1){
        systemType = "ios";
      }else if (window.navigator.userAgent.indexOf("Mac") != -1){
        systemType="mac";
      }else if(window.navigator.userAgent.indexOf("Windows")!= -1){
        systemType="win";
      }else if(window.navigator.userAgent.indexOf("Linux")!= -1){
        systemType="linux";
      }else{
        systemType='wx';
      }
      return systemType;
    },
    isAndroid() { // 获取手机类型
      let u = navigator.userAgent;
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        return 1;
      } else if (isiOS) {
        return 2;
      }
    },
    // 字节转换g
    stringByG (num,type) {
      let g = (num / 1024 / 1024 / 1024 ) , res = 0 , m = (num / 1024 / 1024) , k = (num / 1024);
      if( g >= 1  ){  //大于1G
          res = g.toFixed(2);
          return type==1?(parseFloat(res) + 'GB'):parseFloat(res);
      } 
      if(m >= 1){
          res = m.toFixed(2);
          return type==1?(parseFloat(res) + 'MB'):parseFloat(res);
      }
      if(k >= 1){
        res = k.toFixed(2);
        return type==1?(parseFloat(res) + 'KB'):parseFloat(res);
      }
      return '0';
    },
    // BTD数准换K W
    stringToKOrW (num) {
      let k = (num / 1000) , res = 0 , w = (num / 10000);
      if( w >= 1  ){  //大于1w
        if(window.localStorage.getItem('lang') == 'zh_CN'){
          res = w.toFixed(4);
          return (parseFloat(res) + '万')
        }else{
          res = k.toFixed(3);
          return (parseFloat(res) + 'K')
        }
      } 
      if( k >= 1  ){  //大于1K
        res = k.toFixed(3);
        return window.localStorage.getItem('lang') == 'zh_CN' ? (parseFloat(res) + '千'):(parseFloat(res) + 'K')
      } 
      return this.onlySixNumber(num);
    },
    // BTD数准换W
    stringToW (num) {
      let  k = (num / 1000) ,res = 0 , w = (num / 10000);
      if( w >= 1  ){  //大于1w
        if(window.localStorage.getItem('lang') == 'zh_CN'){
          res = w.toFixed(4);
          return (parseFloat(res) + '万')
        }else{
          res = k.toFixed(3);
          return (parseFloat(res) + 'K')
        }
      } 
      return this.onlySixNumber(num);
    },
    mathCeil(data1,data2){//分页取得页码 
      return Math.ceil(parseInt(data1) / parseInt(data2));
    },
    isPhone (val) {
      const PHONE_RE = /^1(3|4|5|6|7|8|9)\d{9}$/
      return PHONE_RE.test(val)
    },
    isEmail (val) {
      const EMAIL_RE =  /^[a-z0-9\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+(?:\.[a-z0-9\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+)*@(?:[a-z0-9](?:[a-z0-9\-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9\-]*[a-z0-9])?$/i;
      return EMAIL_RE.test(val)
    },
    isPassword (password) {
      return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,15}$/.test(password)
    },
    isidNo(idNo){
      return /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(idNo)
    },
    isNumber (value) {
      return isNaN(value) ? '0' : parseFloat(value);
    },
    fmtNickName(name) {
      return name ? name.slice(0, 1)+ '**' + name.slice(-1) : ''
    },
    fmtPhone(phone) {
      return phone ? phone.slice(0, 3)+ '****' + phone.slice(-4) : ''
    },
    fmtAddress(address) {
      return address ? address.slice(0, 10)+ '****' + address.slice(-10) : ''
    },
    fmtEmail(email) {
      let e = email.split('@');
      return email ? e[0].slice(0, 1)+ '*****@' + e[1] : '';
    }, 
    getLessTime(tmp){
      if(!tmp) tmp = new Date().getTime()
      let time = tmp - new Date().getTime() > 0 ? tmp - new Date().getTime() : 0 ;

      return time
    } ,  
    // getRequestParams() { 
    //   var url = window.location.hash
    //   var theRequest = new Object()
    //   if (url.indexOf("?") != -1) { 
    //     var str = url.split('?')[1]
    //     var strs = str.split("&")
    //     for(var i = 0; i < strs.length; i ++) { 
    //       theRequest[strs[i].split("=")[0]]=decodeURIComponent(strs[i].split("=")[1])
    //     } 
    //   } 
    //   return theRequest
    // },
    /**
     * @param me this 指向
     * @param text 按钮显示的文字
     * @param time 按钮倒计时时间
     * @param dis 按钮disable设置
     * @author wds
     *  */
    setIntervalTime(me, text, time, dis, res_text){// 按钮倒计时
      me[dis] = true;
      let interval = window.setInterval(function(){
        // console.log(text, time);
                
        me[text] = me[time] + 's';

        --me[time];

        if(me[time] < 0){
          me[text] = res_text || REST_TEXT;
          me[time] = REST_TIME;

          me[dis] = false;
          window.clearInterval(interval)
        }
      }, 1000)   
    },
    floatDecimalDiv(num){
      num = num + '';

      return [num.split('.')[0], num.split('.')[1]]
    }
  },
})


// WEBPACK FOOTER //
// ./src/utils/extends.js